// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ntr.is-info {\n        background: #45aaf2;\n}\n.delete-btn {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease;\n  transition: opacity 0.2s ease;\n  pointer-events: none;\n}\ntr:hover .delete-btn {\n  opacity: 1;\n  pointer-events: auto;\n}\n", ""]);
// Exports
module.exports = exports;
